function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  right: 0;\n  transition: left 0.3s ease-out;\n  background-color: #fff;\n  height: ",
        ";\n  width: ",
        ";\n  overflow-x: hidden;\n  overflow-y: auto;\n  left: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  right: 0;\n  transition: left 0.3s ease-out;\n  left: ",
        ";\n  background-color: ",
        ";\n  height: ",
        ";\n  width: ",
        ";\n  max-width: ",
        ";\n  overflow-y: auto;\n  overflow-x: hidden;\n  box-shadow: -3px 0px 3px -3px ",
        " inset;\n  font-family: ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
import styled from "styled-components";
import { hasExtension, getExtension } from "../../util/extensions";
export var PanelsContainer = styled.div.withConfig({
    componentId: "sc-a3cb89d1-0"
})(_templateObject(), function(props) {
    return props.height + "px";
}, function(props) {
    return props.width + "px";
}, function(props) {
    return props.left + "px";
});
export var SidebarContainer = styled.div.withConfig({
    componentId: "sc-a3cb89d1-1"
})(_templateObject1(), function(props) {
    return props.left + "px";
}, function(props) {
    return props.theme.background;
}, function(props) {
    return props.height + "px";
}, function(props) {
    return props.width + "px";
}, function(props) {
    return props.width + "px";
}, function(props) {
    return props.theme.sidebarBoxShadow;
}, function(props) {
    return props.theme["font-family"];
});
/* The sidebar theme is available to all styled components in the sidebar.
 */ var sidebarThemeDefaults = {
    background: "#30353F",
    color: "#D3D3D3",
    "font-family": "Lato, Helvetica Neue, Helvetica, sans-serif",
    sidebarBoxShadow: "rgba(255, 255, 255, 1)",
    selectedColor: "#5DA8A3",
    unselectedColor: "#BBB",
    alternateBackground: "#888"
};
var sidebarThemeExtensions = {};
if (hasExtension("sidebarTheme")) {
    sidebarThemeExtensions = getExtension("sidebarTheme");
    // unselectedBackground → alternateBackground
    if (Object.prototype.hasOwnProperty.call(sidebarThemeExtensions, "unselectedBackground")) {
        sidebarThemeExtensions["alternateBackground"] = sidebarThemeExtensions["unselectedBackground"];
    }
}
export var sidebarTheme = _objectSpread({}, sidebarThemeDefaults, sidebarThemeExtensions);
